import React from "react";

export default function TruckIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.18758 16.2075H2.58008V6.1875H15.0076V16.2075M15.0076 16.2075H8.97758M15.0076 16.2075H17.0326M15.0076 16.2075V11.4H21.4201M21.4201 11.4V16.2075H19.8338M21.4201 11.4L19.0163 8.19H15.0076'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeMiterlimit='10'
      />
      <path
        d='M7.59 17.8128C8.36458 17.8128 8.9925 17.1849 8.9925 16.4103C8.9925 15.6357 8.36458 15.0078 7.59 15.0078C6.81542 15.0078 6.1875 15.6357 6.1875 16.4103C6.1875 17.1849 6.81542 17.8128 7.59 17.8128Z'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeMiterlimit='10'
      />
      <path
        d='M17.0322 16.2108C17.0503 15.8373 17.2138 15.4857 17.4876 15.2311C17.7614 14.9765 18.1239 14.839 18.4977 14.8481C18.8715 14.8571 19.227 15.012 19.4882 15.2796C19.7493 15.5471 19.8955 15.9062 19.8955 16.2802C19.8955 16.6541 19.7493 17.0132 19.4882 17.2807C19.227 17.5483 18.8715 17.7032 18.4977 17.7122C18.1239 17.7213 17.7614 17.5838 17.4876 17.3292C17.2138 17.0746 17.0503 16.723 17.0322 16.3495V16.2108Z'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeMiterlimit='10'
      />
    </svg>
  );
}
